import { Link } from "react-router-dom";

const moreCities = [
  { name: "Palma de Mallorca", slug: "palma-de-mallorca" },
  { name: "Las Palmas", slug: "las-palmas" },
  { name: "San Sebastián", slug: "san-sebastian" },
  { name: "Santander", slug: "santander" },
  { name: "Córdoba", slug: "cordoba" },
  { name: "Valladolid", slug: "valladolid" },
  { name: "Vigo", slug: "vigo" },
  { name: "Gijón", slug: "gijon" },
  { name: "Pamplona", slug: "pamplona" },
  { name: "Salamanca", slug: "salamanca" },
];

export const FooterMoreCities = () => {
  return (
    <div>
      <h4 className="font-semibold mb-4">Más Ciudades</h4>
      <ul className="space-y-2 text-sm">
        {moreCities.map((city) => (
          <li key={city.slug}>
            <Link
              to={`/ciudad/${city.slug}`}
              className="text-muted-foreground hover:text-primary transition-colors"
            >
              {city.name}
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
};
